module.exports = __webpack_public_path__ + "static/slogan.96c5d826.png";